// extracted by mini-css-extract-plugin
export default {"root":"CalculatingLoader_root__qfV0K","content":"CalculatingLoader_content__y-yca","desc":"CalculatingLoader_desc__biA1B","loader":"CalculatingLoader_loader__hj6nt"};